module.exports = __webpack_public_path__ + "6f86822c0f0a6fc1693d6895a80a15ef.svg";